export const BOOKINGLIST  = "BOOKINGLIST"
export const BOOKINGDETAIL = "BOOKINGDETAIL"